/** 헤더/본문 등 `RosterGrid` 배치 구분 — `.tsx`와 분리 (react-refresh/only-export-components) */
export const RosterGridType = {
  HEADER: "HEADER",
  BODY: "BODY",
} as const;

export type RosterGridType =
  (typeof RosterGridType)[keyof typeof RosterGridType];
